import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Compose et déduplique des classes Tailwind. */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
